import { render, staticRenderFns } from "./LoginNew.vue?vue&type=template&id=2d44ce68&scoped=true"
import script from "./LoginNew.vue?vue&type=script&lang=ts"
export * from "./LoginNew.vue?vue&type=script&lang=ts"
import style0 from "./LoginNew.vue?vue&type=style&index=0&id=2d44ce68&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d44ce68",
  null
  
)

export default component.exports